import fuzzysort from 'fuzzysort'
import { type APIProductModel } from '@visorpro/client'

const removeWhitespace = (value: string) => value.replace(/\s/g, '')

/**
 * Fuzzy matches a metadata model name against existing models. A name that
 * differs from an existing model only by whitespace, e.g. "VOLTO 52 T" and
 * "VOLTO 52T", is a perfect match. Dashes and dots remain significant.
 */
export const matchProductModels = (
    modelName: string,
    productModels: readonly APIProductModel[],
): Fuzzysort.KeyResults<APIProductModel> => {
    const results = fuzzysort.go(modelName, productModels, {
        key: 'name',
        threshold: 0.5,
        limit: 5,
    })
    if (results.length > 0 && results[0].score === 1) return results

    const whitespaceInsensitiveResults = fuzzysort.go(
        removeWhitespace(modelName),
        productModels,
        {
            key: (productModel) => removeWhitespace(productModel.name),
            threshold: 1,
            limit: 1,
        },
    )
    return whitespaceInsensitiveResults.length > 0
        ? whitespaceInsensitiveResults
        : results
}
